import React from 'react'
import SearchUI from '../../../widgets/input/SearchUI'
import TabLinkUI from '../../../widgets/output/TabLinkUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'

const TransactionHeaderUI = ({context, bankAccountList, onRefreshClick,
    downloadMode, onDownloadClick, onDownloadCancel, searchFilter, onSearchFilterChange
  }) =>
  <div className='txn_hdr'>
    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          bankAccountList={bankAccountList}
          onRefreshClick={onRefreshClick}
          onDownloadClick={onDownloadClick}
        />
      }
      right={
        <ActionTopRightUI
          context={context}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
        />
      }
    />
  </div>

  const ActionLeftUI = ({ context, bankAccountList, onRefreshClick, onDownloadClick}) =>
    <div className='g_flex_h'>
      <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
      <IconButtonUI icon='icon-download' onClick={onDownloadClick} label='Download' />
      {
        bankAccountList.map((bankAccount, i) =>
          <TabLinkUI label={bankAccount.bankAccountNumber} key={i}
            active={window.location.pathname.includes(bankAccount.bankAccountNumber)}
            to={`/txns2/${bankAccount.bankAccountNumber}`}
          />
        )
      }
    </div>

  const ActionTopRightUI = ({ context, searchFilter, onSearchFilterChange}) =>
    <div className='g_flex_h'>
      <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
    </div>

export default TransactionHeaderUI
